import AUStates from './ru-RU/AU-states.json.js';
import CAStates from './ru-RU/CA-states.json.js';
import CNStates from './ru-RU/CN-states.json.js';
import CompanySize from './ru-RU/company-size.json.js';
import CompanyType from './ru-RU/company-type.json.js';
import countries from './ru-RU/countries.json.js';
import DEStates from './ru-RU/DE-states.json.js';
import HKStates from './ru-RU/HK-states.json.js';
import INStates from './ru-RU/IN-states.json.js';
import industry from './ru-RU/industry.json.js';
import interests from './ru-RU/interests.json.js';
import jobRole from './ru-RU/job-role.json.js';
import levelOfAWSUsage from './ru-RU/level-of-aws-usage.json.js';
import projectTimeline from './ru-RU/project-timeline.json.js';
import PTStates from './ru-RU/PT-states.json.js';
import USStates from './ru-RU/US-states.json.js';
import useCase from './ru-RU/use-case.json.js';
import languagePreference from './ru-RU/language-preference.json.js';
import Navatar from '../ru-RU/translation.json.js';

const dropdownsData = {
    ...AUStates,
    ...CAStates,
    ...CNStates,
    ...CompanySize,
    ...CompanyType,
    ...countries,
    ...DEStates,
    ...HKStates,
    ...INStates,
    ...industry,
    ...interests,
    ...jobRole,
    ...levelOfAWSUsage,
    ...projectTimeline,
    ...PTStates,
    ...USStates,
    ...useCase,
    ...Navatar.translation,
    ...languagePreference,
};

export { dropdownsData as default };
